module.exports = __webpack_public_path__ + "img/2022_jeep-cherokee.3152c05a.png";